
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import Cookies from "js-cookie";
import { logoutStatic } from "../../StateManagement/authSlice";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import SweetAlert from "../Components/SweetAlert/SweetAlert";
import { BASE_URL } from "../Components/Api/Api";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TelInput from "../Components/FormOptions/TelInput";
import { DropDownFormat } from "../Components/FormOptions/DropDownFormat";
import { InputFormat } from "../Components/FormOptions/InputFormat";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
export const FirstStep = ({ onNext , handleFinalStep, nextStep}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const api = "http://api.nanopardazan.com/taab30.aspx";
  const [educationList, seteducationList] = useState([]);
  const [checkLogin, setCheckLogin] = useState(null);
  const [selectedEdu, setSelectedEdu] = useState(null);
  const [initialValues, setInitialValues] = useState([]);

  const [born, setBorn] = useState("");
  const [job, setJob] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [educationId, setEduationId] = useState(null);
  const [insuranceId, setInsuranceId] = useState(null);

  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.EduId,
      label: item.EduTitle,
    }));
  };
  const schema = yup.object({
    name: yup.string().required("نام  وارد نشده است."),
    family: yup.string().required("نام خانوادگی انتخاب نشده است."),
    mob: yup.string().required("شماره وارد نشده است "),
    idcode: yup.string().required("کدملی وارد نشده است."),
    shsh: yup.string().required("   شماره شناسنامه وارد نشده است."),
  });
  const defaultValues = {
    name: "",
    family: "",
    mob: "",
    idcode: "",
    shsh: "",
    birthday: new Date(),
    height: "",
    weight: "",
    Job: "",
  };

  const {
    handleSubmit,
    reset,
    control,
    setValue,
    register,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  const fetchInitialData = async (id) => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));

    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-data",
          Accept: "application/json",
          cmd: "guid",
        },
      });
      if (response.status === 200) {
        const data = await response?.data;
        setCheckLogin(data?.UserId);
        reset({ ...defaultValues });
        return data;
      } else {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
      if (checkLogin === "0") {
          dispatch(logoutStatic());
          navigate("/");
        }
    }, [checkLogin]);
    const fetchData = async () => {};
    const onSubmit = async (data) => {
      console.log(errors)
    const bodyFormData = new FormData();
    bodyFormData.append("step", 1);
    bodyFormData.append("idcode", data?.idcode);
    bodyFormData.append("shsh", data?.shsh);
    bodyFormData.append("name", data?.name);
    bodyFormData.append("family", data?.family);
    bodyFormData.append("height", data?.height);
    bodyFormData.append("weight", data?.weight);
    bodyFormData.append("job", data?.job);
    bodyFormData.append("birthday", new Date(data?.birthday));
    bodyFormData.append("mob", data?.mob);
    bodyFormData.append("guid", Cookies.get("guid"));
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "createinsurance",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        // setGlobalData(data)
        setCheckLogin(data?.UserId);
        setInsuranceId(data?.insuranceid);
        console.log(data?.insuranceid);
       // Check if there are no errors
       onNext(data?.insuranceid, data); // Move to the next step
       if (Object.keys(errors).length === 0) {
      }
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  const handleSendForm = ()=>{

  }
  useEffect(() => {
    fetchInitialData();
  }, []);

  return (
    <div dir="rtl" className="m-5">
      <h5>اطلاعات بیمه شونده را وارد نمایید</h5>
      <br />
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="name"
              type={"text"}
              label="نام"
              errors={errors}
              required={true}
            />
          </Col>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="family"
              type={"text"}
              label="نام خانوادگی"
              errors={errors}
              required={true}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <TelInput
              control={control}
              name="mob"
              type={"tel"}
              defaultValue={""}
              maxLength={"11"}
              label="شماره موبایل"
              errors={errors}
              required={true}
            />
          </Col>
          <Col className=" col-12 col-lg-6">
            <InputFormat
              control={control}
              name="job"
              type={"text"}
              label="شغل"
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6">
            <TelInput
              control={control}
              name="idcode"
              type={"tel"}
              maxLength={"11"}
              defaultValue={""}
              label="کدملی"
              errors={errors}
              required={true}
            />
          </Col>{" "}
          <Col className=" col-12 col-lg-6">
            <TelInput
              control={control}
              maxLength={"10"}
              name="shsh"
              type={"tel"}
              defaultValue={""}
              label="شماره شناسنامه"
              errors={errors}
              required={true}
            />
          </Col>
        </Row>{" "}
        <Row>
          <Col className=" col-12 col-lg-6">
            <TelInput
              control={control}
              name="height"
              type={"tel"}
              defaultValue={""}
              label="قد"
              maxLength={"3"}
              errors={errors}
            />
          </Col>
          <Col className=" col-12 col-lg-6">
            <TelInput
              control={control}
              name="weight"
              type={"tel"}
              defaultValue={""}
              label="وزن"
              maxLength={"3"}
              errors={errors}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-6 ">
            <Form.Group className="mb-3 w-75 ">
              <Form.Label className="fw-bold pb-1">تاریخ تولد</Form.Label>
              <Controller
                control={control}
                name="birthday"
                rules={{ required: true }} //optional
                render={({ field }) => (
                  <>
                    <DatePicker
                      className="txt-center"
                      {...field}
                      format={"YYYY-MM-DD"}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                      defaultValue={"1996-12-02T12:01:39.860Z"}
                    />
                    {errors.BirhDay && <span>تاریخ تولد الزامی است</span>}
                  </>
                )}
              />
            </Form.Group>
          </Col>
        </Row>
        <Col
          className=" m-2 col-12 col-lg-12 d-flex gap-2 align-items-center"
          dir="ltr"
        >
          <Button variant="primary" type="submit">
            بعدی
          </Button>
        
        </Col>
      </Form>
    </div>
  );
};
